import React from 'react'
import { useContentful } from '@pcln/contentful-components'
import MediaCardComponent from '@/components/Promos/MediaCard/MediaCardComponent'
import useContent from '@/hooks/useContent'
import CONTENT from './content'

export default function PriceBreakersMediaCard() {
  const leftPromoBox: any = useContentful('leftPromoBox')
  const promo = useContent(leftPromoBox)

  const hasContentfulData = promo != null
  const mediaCardContent = hasContentfulData ? promo : CONTENT

  return (
    <>
      <MediaCardComponent content={mediaCardContent} />
    </>
  )
}
